import { render, staticRenderFns } from "./DirectionsStat.vue?vue&type=template&id=f65ffe12&scoped=true&"
import script from "./DirectionsStat.vue?vue&type=script&lang=js&"
export * from "./DirectionsStat.vue?vue&type=script&lang=js&"
import style0 from "./DirectionsStat.vue?vue&type=style&index=0&id=f65ffe12&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f65ffe12",
  null
  
)

export default component.exports